import React from "react";

interface EmptyAvatarProps {
  size?: number;
}

export const EmptyAvatar = ({ size = 21 }: EmptyAvatarProps) => {
  return (
    <div
      style={{
        backgroundColor: "rgb(207, 220, 255)",
        borderRadius: "50%",
        width: size,
        height: size,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="CAvatar__default-avatar"
      >
        <mask
          id="mask0_13940_89365"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={size}
          height={size}
          style={{ maskType: "alpha" }}
        >
          <circle cx="10.4043" cy="10.9883" r="10" fill="#CFDCFF"></circle>
        </mask>
        <g mask="url(#mask0_13940_89365)">
          <circle cx="10.405" cy="8.82495" r="3.95581" fill="#F6F6F6"></circle>
          <circle cx="10.4043" cy="21.9395" r="7.75586" fill="#F6F6F6"></circle>
        </g>
      </svg>
    </div>
  );
};
